module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card settings"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('existingDomNode', {
    staticClass: "dataCanvasHolder",
    attrs: {
      "content": _vm.dataCanvas
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "encType": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group no-gutters"
  }, [_c('input-select', {
    attrs: {
      "label": "Image",
      "list": _vm.settings.imageList,
      "value": _vm.settings.image,
      "destinationAddress": "image"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-12",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearAllImages
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary col-12",
    attrs: {
      "for": "uploadImage"
    }
  }, [_vm._v("Upload Image")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "uploadImage"
    },
    on: {
      "change": _vm.uploadImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group no-gutters"
  }, [_c('input-select', {
    staticClass: "col-12",
    attrs: {
      "label": "Display Method",
      "list": _vm.settings.displayMethodList,
      "value": _vm.settings.displayMethod,
      "destinationAddress": "displayMethod"
    }
  }), _vm._v(" "), _c('input-toggle', {
    staticClass: "col-12",
    attrs: {
      "label": "Show Bounds",
      "destinationAddress": "showBounds"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group no-gutters"
  }, [_c('input-select', {
    staticClass: "col-12",
    attrs: {
      "label": "Camera Mode",
      "list": _vm.settings.cameraModeList,
      "value": _vm.settings.cameraMode,
      "destinationAddress": "cameraMode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group no-gutters col-12"
  }, [_c('label', [_vm._v("Automatic Rotation")]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "group"
    }
  }, [_c('input-toggle', {
    staticClass: "col-6",
    attrs: {
      "label": "SpinY",
      "destinationAddress": "autoRotateY"
    }
  }), _c('input-toggle', {
    staticClass: "col-6",
    attrs: {
      "label": "SpinX",
      "destinationAddress": "autoRotateX"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-gutters col-12"
  }, [_c('label', [_vm._v("Camera Positions")]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.settings.cameraPositionList), function(item) {
    return _c('input-button', {
      staticClass: "col-6 col-lg-3",
      attrs: {
        "label": item,
        "destinationAddress": "cameraPosition"
      }
    })
  }))]), _vm._v(" "), _c('input-select', {
    staticClass: "col-12",
    attrs: {
      "label": "Background Color",
      "value": _vm.settings.backgroundColor,
      "list": _vm.settings.backgroundColorList,
      "destinationAddress": "backgroundColor"
    }
  })], 1)]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("RainbowSpace:"), _c('br'), _vm._v("Color Gamut Visualizer")]), _vm._v(" "), _c('p', [_vm._v("A project by "), _c('a', {
    attrs: {
      "href": "http://nuclearpixel.com/about/"
    }
  }, [_vm._v("Admiral Potato")]), _vm._v("."), _c('br'), _c('a', {
    attrs: {
      "href": "https://github.com/AdmiralPotato/rainbowspace"
    }
  }, [_vm._v("Check out the project on GitHub")]), _vm._v(" if you have questions, comments, feedback or issues.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59a2166f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings.vue
// module id = 30
// module chunks = 0